import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
import {SplitText} from 'gsap/SplitText';
gsap.registerPlugin( ScrollTrigger, CustomEase, SplitText );

( function( app ) {
  const COMPONENT = {
    init: function() {},
    finalize: function() {},
    animate: function() {
      function createAnimation( elements, startAnimationObj, animationFunction, start = 'top 90%' ) {
        if ( ( typeof elements === 'string' && document.querySelectorAll( elements ).length > 0 ) || ( typeof elements === 'object' && elements.length > 0 ) ) {
          gsap.set( elements, startAnimationObj );
          const triggers = ScrollTrigger.batch( elements, {
            toggleClass: 'js-animated',
            once: true,
            start: start,
            onEnter: ( batch ) => {
              animationFunction( batch );
            },
          } );

          ScrollTrigger.addEventListener( 'refreshInit', () => {
            triggers.forEach( ( trigger ) => {
              if ( trigger.progress > 0 ) {
                animationFunction( trigger.trigger );
              }
            } );
          } );
        }
      }

      /*
       * Fade on scroll
       */
      const fadeUpClasses = '.js-fade:not(.js-ignore), .js-fade-group > *:not(.js-ignore)';
      function fadeUpTimeline( elements ) {
        const tl = gsap.timeline();

        tl.to( elements, {
          autoAlpha: 1,
          duration: 0.35,
          ease: '0.25,0.1,0.25,1',
          stagger: 0.1,
        }, 0 );

        tl.to( elements, {
          y: 0,
          duration: 1,
          ease: '0, 0, 0.58, 1.0',
          stagger: 0.1,
        }, 0 );
      }
      createAnimation( fadeUpClasses, {autoAlpha: 0, y: 25}, fadeUpTimeline );
    },
    onError: function() {
      document.querySelectorAll( '.js-fade, .js-slide-group > *, .js-slide, .js-slide-group > *' )?.forEach( ( el ) => {
        el.classList.add( 'js-show' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
